import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicGoto extends DesigntimeComponent {
    static staticName = "Logic: Goto";
    static staticId = "logicGoto";
    hasRuntimeView = true;
    selectedNode = "";
    dtAllNodes = [];

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {};
    }

    getDesignerView(outputs) {

        var $designerView = DesigntimeComponent.prototype.getDesignerView.call(this, outputs);

        var key = "targetNode";

        var uniqueId = this.id + "_input_" + key;
        var $formgroup = $("<div class='form-group'></div>");
        $formgroup.append($("<label for='" + uniqueId + "'>Target</label>"));
        var $dropdown = $("<select class='form-control' id='" + uniqueId + "' data-key='" + key + "'></select>")
        for (var i in this.dtAllNodes) {
            $dropdown.append($("<option value='" + this.dtAllNodes[i] + "'>" + this.dtAllNodes[i] + "</option>"))
        }

        $dropdown.find("option[value='" + this.selectedNode + "']").prop("selected", true);

        $dropdown.change(function (e) {
            this.selectedNode = $(e.currentTarget).val();
        }.bind(this));

        $formgroup.append($dropdown);
        $designerView.append($formgroup);

        return $designerView;
    }

    getRuntimeView(context) {
        return $("<div>" + this.selectedNode + "</div>");
    }

    setAllComponents(allComponents) {
        this.dtAllNodes = [];

        for (var i in allComponents) {
            var c = allComponents[i].getComponent();
            if (c)
                this.dtAllNodes.push(c.id);
        }
    }

    exportModel() {
        var res = super.exportModel()
        res.selectedNode = this.selectedNode;
        return res;
    };

    importModel(model) {
        super.importModel(model);
        this.selectedNode = model.selectedNode;
    };

    getGotoNode() {
        return this.selectedNode;
    }
}

export { LogicGoto }
